// extracted by mini-css-extract-plugin
export default {"mainAddress":"CopyAddress_mainAddress__VpUGe","copied":"CopyAddress_copied__dflrm"};